
import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheSubticketgetActions,


    setTheTrackingEditionsActions,
    setTheTicketingsystemtRange1,

    setTheTicketingsystemRange2,
    settheTicketIDSActions, setthePriorityStatus,
    setGeoLoactionStateAction,
    setZoneActions,
    setRegionActions,
    setClientBranchSearchAction,

    setTheTicketSystemlistZoneObject,
    setTheTicketSystemlistRegionObject,
    setTheTicketSystemListStateObject,

    setTheTicketSystemlistBranchObject,
    settheTicketViewIds,
    settheTicketraiseroutes,
    gettheinernalticketlistState,
    gettheinernallistRegion,
    gettheinernalticketlistone,
    gettheinernalListPriority,
    gettheinernalticketlisttatus,
    gettheinernalticketlistbranch,
    settheInnerDashbaordTicketDaterangeOne,
    settheInnerDashbaordTicketDaterangetwo,
    settheClientIdTicketViewHolder,
    settehCLosingopups,
    settheroutesforticketAssignsViews,

    settheSubAssignDashboardRecordsActions, /// sub assign dashboards

    gettheticketdhashboardofROutesActions,
    setthefindthReassings,
    settheTicketingSUbOptionValuesListed
} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeclineIcon from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";
import PendignIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";
import EmployeeIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";

import high from "../../../../Assets/AppComponent/Group 427319195.svg";
import low from "../../../../Assets/AppComponent/Group 427319196.svg";
import medimum from "../../../../Assets/AppComponent/Group 427319197.svg";
import ViewSymblos from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

import Inprogressticket from "../../../../Assets/AppComponent/Union (28).svg";
import reviewticker from "../../../../Assets/AppComponent/Union (31).svg";

import reopenticketslist from "../../../../Assets/AppComponent/Union (33).svg";
import resolvedticket from "../../../../Assets/AppComponent/Union (34).svg";
import Cardimgs from "../../../../Assets/AppComponent/Union (27).svg";



const SubTicket = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const state = useSelector((state) => state);
    const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
    const [newpages, setNewpage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(20);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [DeletePOPUP, setDeletePOPUP] = useState(false);
    const [DeleteID, setDeleteID] = useState("");
    const [EditId, setEditID] = useState();
    const navigate = useNavigate()
    const FileterState = {
        status: state.StateManagementOverallCall.TicketingSUbOptionValues?.value,
        // status: state.NeededdatasListed.TicketDashboardMangements == "All" ?
        //     "" : state.NeededdatasListed.TicketDashboardMangements == "Open" ? "0" :
        //         state.NeededdatasListed.TicketDashboardMangements == "In Progress" ? "1" :
        //             state.NeededdatasListed.TicketDashboardMangements == "Review" ? "2" :
        //                 state.NeededdatasListed.TicketDashboardMangements == "Resolved" ? "3" :
        //                     state.NeededdatasListed.TicketDashboardMangements == "Reopen" ? "4" :
        //                         state.NeededdatasListed.TicketDashboardMangements == "Reject" && "5",
        // priority: state.ClientBranchIDs.InernalTicketList_Priority?.value,

        // status: "0",
        priority: "",

    };
    const [selectDisplay, setDisplay] = useState([]);

    const [selectVal, SetSelectval] = useState(FileterState);

    const DashboardDatas = useSelector((state) => state.SubAssignTicketDasboardDataHolds.SubAssignTicketDasboardDataRecords)

    const [StatusTicket, setstatustcket] = useState({
        value: state.StateManagementOverallCall.TicketingSUbOptionValues?.value
        , label: state.StateManagementOverallCall.TicketingSUbOptionValues?.label
    })


    // const [StatusTicket, setstatustcket] = useState({ value: "0", label: "Open" })

    const [FState, SetStates] = useState(false);

    const [FindZeroticket, setFindZeroTickets] = useState(false);
    const [CountFroActions, setCountForActions] = useState(0);
    // Define state to manage checkbox selections, if needed
    const [selectedIds, setSelectedIds] = useState([]);
    const [checked, setchecked] = useState(false);
    const formDatas = new FormData();

    const [ListedIds, setlistedids] = useState([]);

    // console.log(state.NeededdatasListed.TicketDashboardMangements, StatusTicket , "state.StateManagementOverallCall.TicketsStatusState");

    ////--_FIlter--------------------------
    const [Filter, SetFilter] = useState(true);
    const [TracketReport, setTicketReport] = useState({
        OpenTicket: 2,
        Closeticker: 3,
        PendingTickets: 4,
    });

    const optionsstatus = [
        { value: "", label: "All" },

        { value: "0", label: "Open" },
        { value: "1", label: "In Progress" },
        { value: "2", label: "Review" },
        { value: "over_due", label: "Over Due" },
        { value: "5", label: "Reject" },
        { value: "4", label: "Reopened" },
        { value: "3", label: "Resolved" },


    ];

    const priorityoptions = [
        {
            value: "",
            label: "All"
        },
        {
            value: "0",
            label: "Low"
        },
        {
            value: "1",
            label: "Medium"

        },
        {
            value: "2",
            label: "High"

        }
    ];
    const [PriorityValues, setPriorityValues] = useState({ value: "", label: "All" })
    const [mulitibranch, setMulibranch] = useState([state.ClientBranchIDs.InernalListTicketSystem_List_Branch]);
    const [Searchbranch, setsearchbranch] = useState("");

    const [Optionsbranch, setOptionsbranch] = useState([]);




    const [multiselect1, setMuliselect1] = useState([state.ClientBranchIDs.InernalListTicketSystem_List_Region,]);
    const [multiselect3, setMuliselect3] = useState([state.ClientBranchIDs.InernalListTicketSystem_List_Zone,]);
    const [nameList5, setOptions5] = useState([]);
    const [Zone, setZone] = useState([]);

    const [Clientid, setclientid] = useState(state.ClientBranchIDs?.InernalListTicketSystem_List_Branch?.value)
    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.InernalListTicketSystem_List_Zone?.value,
        state: state.ClientBranchIDs.InernallistTicketSystem_list_State?.value,
        region: state.ClientBranchIDs.InernalListTicketSystem_List_Region?.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.InernallistTicketSystem_list_State,]);
    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [REgion, setRegion] = useState([]);
    let Ids = [];
    const [nameList4, setOptions4] = useState([]);


    ///----Filter-----------------------

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);

    const [activeButton, setActiveButton] = useState("0");

    const [place, SetPlace] = useState("All");
    const [sel, setSelected] = useState();
    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(state.StateManagementOverallCall.TicketingsystemInnerDashbaordTicektsRange1);
    var gt = convert(state.StateManagementOverallCall.TicketingsystemInnerDashbaordTicketRange2);
    var startweet = convert(startOfWeek(new Date()));
    var endweek = convert(endOfWeek(new Date()))
    const [range, setrange] = useState(
        state.StateManagementOverallCall.TicketingsystemInnerDashbaordTicektsRange1 == ""
            ? // [it, gt]
            [startweet, endweek]
            : [it, gt]
    );
    const handlechangedate = (value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(settheInnerDashbaordTicketDaterangeOne(range[0]));
            dispatch(settheInnerDashbaordTicketDaterangetwo(range[1]));
        }
    }, [range]);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };


    const handleButtonClick = (button) => {
        SetSelectval({
            ...selectVal,
            status: button
        })
        setActiveButton(button);


        if (button == 0) {
            setstatustcket({ value: "0", label: "Open" })
        }
        else if (button == 1) {
            setstatustcket({ value: "1", label: "In Progress" })

        }

        else if (button == 2) {
            setstatustcket({ value: "2", label: "Review" })

        }

        else if (button == 3) {
            setstatustcket({ value: "3", label: "Resolved" })

        }

        else if (button == 4) {
            setstatustcket({ value: "4", label: "Reopened" })

        }
        else if (button == 5) {
            setstatustcket({ value: "5", label: "Reject" })

        }

        // SetActiveBars(button);
    };

    const [yearAndMonth, setYearMpnth] = useState();
    const date = new Date();
    const months =
        date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const displaydate =
        date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const YearList = date.getFullYear();
    //var yearAndMonth = `${date.getFullYear()}-${months}`;
    useEffect(() => {
        setYearMpnth(`${date.getFullYear()}-${months}`);
    }, []);
    const [Datestate, setdata] = useState({
        date: displaydate,
        month: months,
        year: YearList,
    });


    useEffect(() => {
        dispatch(settehCLosingopups(1))
        dispatch(settheTicketraiseroutes(6))
        dispatch(setthefindthReassings(3))

    }, [])




    // useEffect(() => {
    //     const payload = {
    //         ticket_assign: true

    //     }
    //     dispatch(settheSubAssignDashboardRecordsActions(payload))
    // }, [])



    // console.log(state.SubAssignTicketDasboardDataHolds.SubAssignTicketDasboardDataRecords , "SubAssignTicketDasboardDataRecords");

    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            const payload = {
                search: search,
                page_size: dtpagesize,
                page: dtpageindex,
                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                // status: selectVal.status,
                status: selectVal.status == "over_due" ? "" : selectVal.status,
                priority: selectVal.priority,
                // state: datas.state,
                // region: datas.region,
                // zone: datas.zone,
                // client: Clientid,
                ticket_assign: false,
                over_due: selectVal.status == "over_due" ? true : ""

            };
            // dispatch(  settheSubticketgetActions,
            //     (payload));
            dispatch(settheSubticketgetActions(payload))
        }
    }, [dtpageindex, range, selectVal.status, selectVal.priority, search]);

    useEffect(() => {
        dispatch(gettheticketdhashboardofROutesActions(3))
    }, [])




    useEffect(() => {
        if (state.TrackingrecordgetList.TrackingReport) {
            const Options = {
                OpenTicket:
                    state.TrackingrecordgetList.TrackingReport.open_tracking_count,
                Closeticker:
                    state.TrackingrecordgetList.TrackingReport.close_tracking_count,
                PendingTickets:
                    state.TrackingrecordgetList.TrackingReport.pending_tracking_count,
            };
            setTicketReport(Options);
        }
    }, [state.TrackingrecordgetList.TrackingReport]);



    useEffect(() => {
        if (state.TrackingrecordgetList.TrackingReport != null

        ) {
            if (
                state.TrackingrecordgetList.TrackingReport.open_tracking_count == 0 &&
                state.TrackingrecordgetList.TrackingReport.close_tracking_count == 0 &&
                state.TrackingrecordgetList.TrackingReport.pending_tracking_count == 0
            ) {

                setFindZeroTickets(false);

            } else if (
                state.TrackingrecordgetList.TrackingReport.open_tracking_count != 0 ||
                state.TrackingrecordgetList.TrackingReport.close_tracking_count != 0 ||
                state.TrackingrecordgetList.TrackingReport.pending_tracking_count != 0
            ) {

                setFindZeroTickets(true);
            }

        }

    }, [state.TrackingrecordgetList.TrackingReport]);
    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };

    const cleaningrange = () => {
        //setrange([gt,it]);
    };
    const HandlethepriorityChanges = (e) => {
if(e != null ){
            setPriorityValues(e);
        SetSelectval({
            ...selectVal,
            priority: e.value
        })
}
else {
             setPriorityValues(null);
        SetSelectval({
            ...selectVal,
            priority: ""
        })
}
    }




    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);




    const getIconColor = (createdAt, expireTime) => {
        // Convert expireTime to an integer
        const expireDays = parseInt(3);

        // Calculate the expiration date by adding expireDays to createdAt
        const expirationDate = addDays(createdAt, expireDays);

        // Calculate the difference in days between expiration date and current date
        const daysDifference = differenceInDays(expirationDate, new Date());

        // Log the difference in days for debugging
        console.log(daysDifference, "daysDifference", expirationDate, expireDays);

        // Determine the color based on the difference in days
        if (daysDifference < 0 || daysDifference == 0) {
            return "red"; // Expired, set color to red
        }
        // else if (daysDifference <= 2) {
        else if (daysDifference == 2) {
            // return "yellow"; // Expiring within 7 days, set color to yellow
            return "green";
        } else if (daysDifference == 1) {
            return "red"; // Not expiring soon, set color to green
        }
    };



    const capitalizeEachWord = (str) => {
        return str
            .split(' ') // Split the string into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };

    useEffect(() => {
        dispatch(settheroutesforticketAssignsViews(0))
    }, [])


    const HandletheClientTicketDetais = (datas) => {
        // console.log(datas, "Ticket Details laksdjlkajsd ", datas.client_ticket_id);
        if (datas != null) {
            dispatch(settheTicketViewIds(datas.id))

            dispatch(settheClientIdTicketViewHolder(datas.client_ticket_id.id))
            // dispatch(settheTicketIDSActions(datas.client_ticket_id))
            // dispatch(settheTicketViewIds(datas.client_ticket_id)) /// client Ticket view only if the client_ticket_id have te id
            // navigate("/sub_ticket_client_view")
            // navigate("/ticket_client_view")
            navigate("/ticket_externalview");

        }
        else {
        }

    }
    const columns = [
        {
            Header: "Ticket Number",
            accessor: "",
            Cell: ({ row }) => {
                const userId = row.original.id;
                const lastFourDigits = userId ? userId.toString().slice(-6) : "---";
                const originalString = row.original.status;
                const ticketnum = row.original.ticket_number;

                const createdAt = row.original.created_at
                    ? parseISO(row.original.created_at)
                    : null;
                const expireTime = row.original.sub_category_id?.TAT
                    ? row.original.sub_category_id.TAT
                    : null;
                // const expireTime = true ? 3 : null;
                const iconColor =
                    createdAt && expireTime
                        ? getIconColor(createdAt, expireTime)
                        : "grey"; // Default color if dates are not available

                return (
                    <>
                        {userId ? (
                            <span
                                style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center", width: "107px" }}
                            >
                                {`Sub-${ticketnum}`}

                            </span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },


        {
            Header: " Client Ticket Number",
            accessor: "",
            Cell: ({ row }) => {
                const userId = row.original.id;
                const lastFourDigits = userId ? userId.toString().slice(-6) : "---";
                const originalString = row.original.client_ticket_id?.ticket_number;
                const ticketnum = row.original.ticket_number;

                const createdAt = row.original.created_at
                    ? parseISO(row.original.created_at)
                    : null;
                const expireTime = row.original.sub_category_id?.TAT
                    ? row.original.sub_category_id.TAT
                    : null;
                // const expireTime = true ? 3 : null;
                const iconColor =
                    createdAt && expireTime
                        ? getIconColor(createdAt, expireTime)
                        : "grey"; // Default color if dates are not available

                return (
                    <>
                        {userId ? (
                            <span
                                style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "flex-start", width: "107px" }}
                            >
                                {/* {`Client-${ticketnum}`} */}

                                {`${originalString}`}

                            </span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },


        {
            Header: "Created Date",
            accessor: "created_at",
            Cell: (row) => {
                const dateString = row.row.original.created_at;
                const dateObject = new Date(dateString);
                const hours = dateObject.getHours();
                const minutes = dateObject.getMinutes();
                const seconds = dateObject.getSeconds();
                const amOrPm = hours >= 12 ? "PM" : "AM";
                const twelveHourFormat = hours % 12 || 12;

                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                return (
                    <>
                        <div className="CreatedDatelisted">
                            {/* {`${row.row.original.created_at.slice(0, 10)}`} */}
                            {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at) : ""}
                            {/* <p> {formatDate(row.row.original.created_at)}</p> */}

                        </div>
                    </>
                );
            },
        },


        // {
        //     Header: "Department",
        //     accessor: "",
        //     Cell: ({ cell }) => {
        //         let data = cell.row.original;
        //         return (
        //             <div className="ParaTickets">
        //                 <p> {data.department_id?.department_name ?
        //                     capitalizeEachWord(data.department_id?.department_name.toLowerCase()) :
        //                     "-"

        //                 }</p>
        //             </div>
        //         );
        //     },
        // },

        {
            Header: "Category",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.internal_category_id?.issue_category_id ?
                            capitalizeEachWord(data.internal_category_id?.issue_category_id.name.toLowerCase()) :
                            "-"

                        }</p>
                    </div>
                );
            },
        },



        {
            Header: "Subcategory",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.internal_category_id?.name ?
                            capitalizeEachWord(data.internal_category_id?.name.toLowerCase()) : "-"}</p>
                    </div>
                );
            },
        },

        {
            Header: "Description",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p
                        //  data-tooltip-id="my-tooltip" data-tooltip-content={data.remarks} 
                        >{data.remarks ? truncateText(capitalizeEachWord(data.remarks.toLowerCase()), 60) : "-"}</p>

                        {/* <p> {data.remarks ? capitalizeEachWord(data.remarks.toLowerCase()) : "-"}</p> */}
                    </div>
                );
            },
        },




        {
            Header: "Priority",
            accessor: "Priority",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Priority colors
                const priorityColor = data?.priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data?.priority === "0" || data?.priority === "1" || data?.priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"

                                }}
                            >
                                {data?.priority === "0" ? "Low" : data?.priority === "1" ? "Medium" : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },
        {
            Header: "Criticality",

            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                const priorityColor = data?.internal_category_id?.Priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.internal_category_id?.Priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.internal_category_id?.Priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data.internal_category_id?.Priority === "0" || data.internal_category_id?.Priority === "1" || data.internal_category_id?.Priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"
                                }}
                            >
                                {data.internal_category_id?.Priority === "0"
                                    ? "Low"
                                    : data.internal_category_id?.Priority === "1"
                                        ? "Medium"
                                        : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },


        {
            Header: "Client tickets",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets" onClick={(e) => {
                        e.stopPropagation();
                        if (data.id != null) {
                            dispatch(settehCLosingopups(1))
                            HandletheClientTicketDetais(data)
                        }
                        else {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }}>
                        <span>
                            <>
                                {data.client_ticket_id != null ?
                                    <button className='Buttonstatus'
                                        style={{
                                            background: "#FFF8E5", // Default for Reopen - light red background
                                            color: "#FFB800",
                                        }}
                                    >
                                        View

                                    </button>
                                    :
                                    "--"}
                            </>
                        </span>
                    </div>
                );
            },
        },

        {
            Header: "Status",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="TicketButtons">

                        <>
                            <button className='Buttonstatus'
                                style={{
                                    background: data.status == 0 ? "#FDEDE9" : // Open - light background
                                        data.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                            data.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                data.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                    data.status == 4 ? "#FFDDDD"
                                                        : data.status == 5 ?
                                                            "#FFDDDD" : data.status == 6 ?
                                                                "#E7F8ED" : data.status == 7 && "#FFDDDD", // Default for Reopen - light red background
                                    color: data.status == 0 ? "#ed4c28" : // Open - red text
                                        data.status == 1 ? "#FFB800" : // In Progress - yellow text
                                            data.status == 2 ? "#12B749" : // Completed - green text
                                                data.status == 3 ? "#8BC34A" : // Close - light green text for Close                                                    
                                                    data.status == 4 ? "#ed4c28"
                                                        : data.status == 5 ?
                                                            "#ed4c28" : data.status == 6 ?
                                                                "#12B749" : data.status == 7 && "#ed4c28",
                                }}
                            >
                                {data.status == 0 ? "Open" :
                                    data.status == 1 ? "In Progress" :
                                        data.status == 2 ? "Review" :
                                            data.status == 3 ? "Resolved" : data.status == 4 ? "Reopened" :
                                                data.status == 5 ? "Reject" :
                                                    data.status == 6 ? "Reassign" :
                                                        data.status == 7 && "Reject"}


                            </button>

                        </>

                    </div>
                );
            },
        },



    ];

    const ClearState = (Counts) => {
        if (Counts == 2) {
            SetSelectval({
                ...selectVal,
                status: "",
            });
            setstatustcket({ value: "", label: "All" })
            setActiveButton("")
            setdtPageindex(1);
            dispatch(settheTicketingSUbOptionValuesListed({ value: "", label: "All" }))
        }
    };

    //--------_____Filter-----------Based---On----Status--
    const count = (Counts, values, sel, SelectedValues) => {
        setdtPageindex(1);
        setSelected(sel);
        SetStates(true);
        setActiveButton(sel)
        // console.log(SelectedValues, sel, "we[ouoieqpwo[epqowepoqw[epopewopowieoiqwue");
        setstatustcket(SelectedValues)
        SetSelectval({
            ///Completed
            ...selectVal,
            status: sel,
        });

        dispatch(settheTicketingSUbOptionValuesListed(SelectedValues));




    };



    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);

        }
    };

    const HandleTicketViewparts = (data) => {
        dispatch(settheTicketIDSActions(data.id)); /// ticket id
        // navigate("/internal_ticketview")
        navigate("/sub_ticket_internal_view")
    }


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3>Sub Assigned</h3>
                    </div>
                </div>


                <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
                    <ReactTable
                        data={state.SubticketForthemanagements.SubticketManagement}
                        columns={columns}
                        totalItems={state.SubticketForthemanagements.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}

                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        datacount={state.SubticketForthemanagements.Total_Count}
                        values={StatusTicket}
                        options={optionsstatus}
                        ApproveRequestFilter={true}
                        Filter={Filter}
                        count={count}
                        ClearState={ClearState}
                        placeHold={place}
                        MakeCreate={true}
                        ViewParts={(e) => {
                            HandleTicketViewparts(e);
                        }}
                        PriorityKeys={true}
                        HandlethepriorityChanges={HandlethepriorityChanges}
                        priorityoptions={priorityoptions}
                        PriorityValues={PriorityValues}
                        Nodatarecord={"No Tickets Available"}

                    />

                </div>
            </div>



        </>
    );
};

export default SubTicket;
